module.exports = __webpack_public_path__ + "static/media/genrate.e62de8f6.svg";